module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-08.68403926.png";